function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.4271 4.55396L10.1484 6.03906L18.052 12.8441L19.3307 11.359C20.5073 9.99239 20.5978 8.05843 19.6807 6.60997L21.4678 4.94746C22.6317 3.86473 22.596 2.01071 21.3914 0.973524C20.1868 -0.0636654 18.348 0.176502 17.4502 1.48831L16.0717 3.50249C14.503 2.81061 12.6038 3.18732 11.4271 4.55396Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.4884 18.774C1.23282 17.6929 1.09134 15.7987 2.1724 14.5431L8.13224 7.62111C9.21329 6.36553 11.1075 6.22405 12.3631 7.3051L16.4624 10.8346C17.718 11.9156 17.8594 13.8099 16.7784 15.0654L16.5934 15.2803L13.7985 18.5264L11.0036 21.7726L10.8185 21.9874C9.73749 23.243 7.84327 23.3845 6.58769 22.3034L2.4884 18.774Z",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var SvgNursingRoom = function SvgNursingRoom(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNursingRoom, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nursingRoom.43f9982b.svg";
export { ForwardRef as ReactComponent };